import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            feedArchive: [],
            feedId: null,
            multiLanguage: null,
            dateFrom: null,
            dateTo: null,
            pageNumber: 1,
            pageSize: 10,
            totalCount: 0,
            isLoading: false
        }
    },
    getters,
    actions,
    mutations
}
